module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_024"
    }
  }, [_vm._v("Don’t bend the needle, especially when it’s already in the wool. The tip of the needle might break off and be stuck inside of your sculpture. That will turn your wooly critter into an airport security threat! Also don’t poke too hard or too much. I know it’s tempting, but relax. Third, pay attention to where you are poking with the felting needle and watch your fingers. With some practice, you won’t have any trouble at all.")])]), _c('a', {
    attrs: {
      "id": "file_024"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d3bb18d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_024.vue
// module id = 123
// module chunks = 0